import React, { useState } from 'react'
import { ProductPopupSelectorProps } from './ProductPopupSelector.types'
import styles from './ProductPopupSelector.module.scss'
import cl from 'classnames'
import { HorizontalLine, Input, Text1, ToolPopupContainer } from 'components/shared'
import { Select } from 'components/shared/Select'
import { ObjectSelectButton } from 'components/shared/ObjectSelectSection/ObjectSelectButton'

const ProductPopupSelectorComponent = (props: ProductPopupSelectorProps) => {
  const {
    className,
    style,
    selectedOptionIds = [],
    objectOptionList = [],
    sourceSelectProps,
    brandSelectProps,
    onClose,
    onObjectClick
  } = props

  const [searchText, setSearchText] = useState<string>('')

  return (
    <ToolPopupContainer
      className={className}
      style={style}
      title='Manage attached products'
      onClose={onClose}
      bottomButtonsProps={[{
        children: 'Done',
        preset: 'primary',
        onClick: onClose
      }]}
    >
      <div className={styles.selectorsContainer}>
        <div className={styles.selector}>
          <Text1>Source</Text1>
          <Select {...sourceSelectProps} />
        </div>
        <div className={styles.selector}>
          <Text1>Brand</Text1>
          <Select {...brandSelectProps} />
        </div>
        <Input
          placeholder='Search...'
          containerProps={{
            className: styles.searchInput
          }}
          value={searchText}
          onChange={setSearchText}
        />
      </div>
      <HorizontalLine />

      <div className={cl(styles.body, styles.scrollable)}>
        {objectOptionList
          .filter(obj => obj.label.toLowerCase().includes(searchText.trim().toLowerCase()))
          .map(objectProps => {
            return (
              <ObjectSelectButton
                key={objectProps.id || objectProps.externalId}
                isSelected={selectedOptionIds.includes(objectProps.id)}
                isRemovable={objectProps.removable}
                onClick={() => onObjectClick(objectProps.id)}
                {...objectProps}
              />
            )
          })}
      </div>
    </ToolPopupContainer>
  )
}

const ProductPopupSelector = ProductPopupSelectorComponent
export { ProductPopupSelector }
